<template>
  <div class="justify-content-center text-left dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div
      class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ $t('CreateProductType.header') }}</h2>
      </div>
      <ValidationObserver ref="observer"
                          class="row col-12"
                          v-slot="{invalid}"
                          tag="form"
                          @submit.prevent="submit()">
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.name') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="name" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.price') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="price"
                rules="required|greaterThanZero"
                v-slot="{errors, classes}">
                <b-form-input
                  type="number"
                  :class="{...classes, myInput: true}"
                  v-model="price" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="row col-4 offset-7">
          <b-button
            type="submit"
            class="myButton align-middle">
            {{ $t("common.Create") }}
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'ProductTypeCreate',
  computed: {
    name: {
      get() {
        return this.$store.state.createProductType.name;
      },
      set(val) {
        this.setName(val);
      }
    },
    price: {
      get() {
        return this.$store.state.createProductType.price;
      },
      set(val) {
        this.setPrice(val);
      }
    }
  },
  methods: {
    ...mapActions({
      resetContext: 'createProductType/resetContext',
      createProductType: 'createProductType/createProductType'
    }),
    ...mapMutations({ setName: 'createProductType/setName',
      setPrice: 'createProductType/setPrice' }),
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.createProductType()
          .then(() => {
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('CreateProductType.SuccessToast.Body'), {
              title: this.$t('CreateProductType.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.users.producttypes.view' });
          })
          .catch(() => {
            this.$root.$bvToast.toast(this.$t('CreateProductType.FailToast.Body'), {
              title: this.$t('CreateProductType.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
